import {
    Solar4gCellularInfo,
    Solar4gCellularStatus,
    TimeInfoDaylightSavingMode,
    TimeInfoSyncMode,
} from '@EcamModel/model';
import { solar4gCameraHttpController } from '@controllers/index';
import _ from 'lodash';
import { useState } from 'react';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';

export default function useMileSightSolar() {
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const { id } = useParams();

    const getSolar4gCameraInfo = async () => {
        const response = await solar4gCameraHttpController.getLatestInfoByCameraId(Number(id));
        return response;
    };

    const {
        data: solar4gCamera,
        error,
        isLoading: loading,
    } = useQuery(['solar4gCamera', id], getSolar4gCameraInfo, {
        staleTime: 5 * 60 * 1000,
        refetchOnWindowFocus: false,
        enabled: !!id,
    });

    const Solar4gCaptureInfo = solar4gCamera?.Solar4gCaptureInfo;

    const Solar4gSchedule = solar4gCamera?.Solar4gSchedule;

    const Solar4gImageInfo = solar4gCamera?.Solar4gImageInfo;

    const Solar4gDaySection = solar4gCamera?.Solar4gDaySection;

    const Solar4gAlarmROI = solar4gCamera?.Solar4gAlarmROI;

    const Solar4gSysInfo = solar4gCamera?.Solar4gSysInfo

    const partsTimeTrigger = Solar4gSchedule?.Trigger?.split(';');

    const enableValueInContinuousCapture = Solar4gAlarmROI?.Region[0]?.enable;

    const valueImageSettings: string = !(_.isNil(Solar4gCaptureInfo?.Width) || _.isNil(Solar4gCaptureInfo?.Height))
        ? `${Solar4gCaptureInfo?.Width} x ${Solar4gCaptureInfo?.Height}`
        : '';

    const cellularStatus = solar4gCamera?.Solar4gCellularStatus;
    const cellularSettings = solar4gCamera?.Solar4gCellularInfo;
    const systemTimeMilesight = solar4gCamera?.Solar4gTimeInfo;

    const [status, setStatus] = useState<Solar4gCellularStatus>({} as Solar4gCellularStatus);
    const settings = cellularSettings ?? ({} as Solar4gCellularInfo);
    const [cellularInfo, setCellularInfo] = useState<Solar4gCellularInfo>({} as Solar4gCellularInfo);

    const checkTimeInfo = () => {
        const syncMode = {
            [TimeInfoSyncMode.GPS]: 'Auto',
            [TimeInfoSyncMode.MANUAL]: 'Manual',
        };

        const daylightSaving = {
            [TimeInfoDaylightSavingMode.Disable]: 'Disable',
            [TimeInfoDaylightSavingMode.Automatic]: 'Automatic',
        };

        return {
            syncMode: syncMode[systemTimeMilesight?.SyncMode!],
            daylightSaving: daylightSaving[systemTimeMilesight?.DaylightSaving!],
        };
    };

    return {
        solar4gCamera,
        //Milesight Solar
        valueImageSettings,
        isLoading,
        loading,
        setIsLoading,
        partsTimeTrigger,
        Solar4gCaptureInfo,
        Solar4gSchedule,
        Solar4gAlarmROI,
        Solar4gImageInfo,
        Solar4gDaySection,
        Solar4gSysInfo,
        // Cellular status
        status,
        settings,
        //Set the system time
        checkTimeInfo,
        cellularStatus,
        systemTimeMilesight,
        setStatus,
        getSolar4gCameraInfo,
        enableValueInContinuousCapture,
        cellularSettings,

        // Cellular info
        cellularInfo,
        setCellularInfo,
    };
}
